<template>
  <div class="page">
    <h1 class="page-title" data-title="Paramètres">Paramètres</h1>
    <button @click="logout" class="btn">Déconnexion</button>
  </div>
</template>

<script>
export default {
  methods: {
    logout () {
      this.$store.dispatch('login', false)
      this.$router.push({ path: '/login' })
    }
  }
}
</script>
